import React, { Component } from "react";
import * as d3 from "d3";
import $ from "jquery";
import moment from "moment";
import PropTypes from "prop-types";
import "./newLine.style.css";

class NewLine extends Component {
  state = {
    display: {
      m: { t: 20, b: 30, r: 30, l: 40 },
    },
  };

  renderChart = ({ data, width }) => {
    console.log({ data });
    console.log("======================ne line========");
    var { chartId, height } = this.props;
    let { display } = this.state,
      m = display.m,
      w = width - m.l - m.r,
      h = height - m.t - m.b;

    const z = d3.scale
      .linear()
      .domain([0, 1, 2])
      .range(["#81efde", "#4c6ead", "#8775a7"]);

    const svg = d3
      .select(`#${chartId}`)
      .append("svg")
      .attr("height", h + m.t + m.b)
      .attr("width", w + m.l + m.r)
      .attr("class", "chart")
      .append("g")
      .attr("transform", "translate(" + 60 + "," + 10 + ")");

    const x = d3.time.scale().range([0, w]);
    const y = d3.scale.linear().rangeRound([h, 0]);

    var ary = [];
    data.forEach(function (d) {
      console.log(d);
      ary.push(d.data);
    });
    x.domain(d3.extent(d3.merge(ary), (d) => new Date(d[0])));
    y.domain(d3.extent(d3.merge(ary), (d) => d[1]));

    // axis d3 func
    let Axis = this.axis(w, x, y);

    var line = d3.svg
      .line()
      //   .interpolate("monotone")
      .x((d) => x(d[0]))
      .y((d) => y(d[1]));

    // axis svg tags
    this.axis_svg(svg, Axis, h);

    var series = svg
      .selectAll(".series")
      .data(data)
      .enter()
      .append("g")
      .attr("class", "series");
    series
      .append("path")
      .attr("class", "line")
      .attr("d", (d) => line(d.data))
      .style("stroke", (d, i) => z(i))
      .style("fill", "none")
      .style("stroke-width", "2px");

    var mouseG = svg.append("g").attr("class", "mouse-over-effects");

    mouseG
      .append("path") // vertical line to follow mouse
      .attr("class", "mouse-line")
      .style("stroke", "#92939d")
      .style("stroke-width", "1px")
      .style("opacity", "0");

    // new tooltip
    this.tooltip_svg(mouseG);

    var lines = document.getElementsByClassName("line");
    mouseG
      .append("svg:rect") // append a rect to catch mouse movements on canvas
      .attr("width", w)
      .attr("height", h)
      .attr("fill", "none")
      .attr("pointer-events", "all")

      .on("mouseout", function () {
        d3.select(".mouse-line").style("opacity", "0");
        d3.selectAll(".newToolTip").style("opacity", "0");
      })
      .on("mouseover", function () {
        d3.select(".mouse-line").style("opacity", "1");
        d3.selectAll(".newToolTip").style("opacity", "0.8");
      })

      .on("mousemove", function () {
        // mouse moving over canvas
        var mouse = d3.mouse(this);
        d3.select(".mouse-line").attr("d", function () {
          var d = "M" + mouse[0] + "," + h;
          d += " " + mouse[0] + "," + 0;
          return d;
        });

        // new tooltip
        d3.selectAll(".newToolTip").attr("transform", function (d, i) {
          var xDate = x.invert(mouse[0]);

          // portfolio and benchmark value
          if (xDate !== "") {
            var dataFilter = (data) =>
              data["data"].filter((e, i) => {
                let k = moment(e[0], x).format("MM YYYY");
                let l = moment(xDate, x).format("MM YYYY");

                return k === l;
              });
          }
          let new_portfolio = dataFilter(data[0]);
          let new_benchmark = dataFilter(data[1]);

          if (data.length > 2) {
            var orig_benchmark = data.length > 2 ? dataFilter(data[2]) : [];
          }
          // let port2  = data[0]["data"].find( e => e[0] == xDate)

          var beginning = 0,
            end = lines[i].getTotalLength(),
            target = null;

          while (true) {
            target = Math.floor((beginning + end) / 2);
            let pos = lines[i].getPointAtLength(target);
            if (
              (target === end || target === beginning) &&
              pos.x !== mouse[0]
            ) {
              break;
            }
            if (pos.x > mouse[0]) end = target;
            else if (pos.x < mouse[0]) beginning = target;
            else break; //position found
          }
          d3.select(this)
            .select("#axis_date")
            .text(d3.time.format("%d-%b-%y")(xDate));

          if (orig_benchmark) {
            if (new_portfolio.length > 0) {
              d3.select("#portfolio_text").text(
                "IQCIO Portfolio : " + new_portfolio[0][1].toFixed(2)
              );
            }
            if (new_benchmark.length > 0) {
              d3.select("#benchmark_text").text(
                `${data[1]["label"] ? data[1]["label"] : "Benchmark"} : ` +
                  new_benchmark[0][1].toFixed(2)
              );
            } else {
              d3.select("#benchmark_text").text(
                `${data[1]["label"] ? data[1]["label"] : "Benchmark"} : ` + "-"
              );
            }
            try {
              if (orig_benchmark) {
                d3.select("#Orig_benchmark_text").text(
                  `${data[2]["label"].slice(
                    0,
                    20
                  )} : ${orig_benchmark[0][1].toFixed(2)}`
                );
              }
            } catch (error) {
              d3.select("#Orig_benchmark_text").text(
                `${data[2]["label"].slice(0, 20)} : -`
              );
            }
          } else {
            if (new_portfolio.length > 0) {
              d3.select("#portfolio_text").text(
                "Portfolio : " + new_portfolio[0][1].toFixed(2)
              );
            }
            if (new_benchmark.length > 0) {
              d3.select("#benchmark_text").text(
                "Benchmark: " + new_benchmark[0][1].toFixed(2)
              );
            }
          }

          // let wid = data.length > 2 ? 230 : 180;
          let wid = 230;
          let move_left = mouse[0] - wid;
          let wd = w / 2;
          if (mouse[0] >= wd) {
            return "translate(" + move_left + "," + 20 + ")";
          } else {
            return "translate(" + mouse[0] + "," + 20 + ")";
          }
          // return "translate(" + mouse[0] + "," + pos.y + ")";
        });
      });
  };

  axis = (w, x, y) => {
    let xAxis = d3.svg
      .axis()
      .scale(x)
      .innerTickSize(0)
      .outerTickSize(0)
      .orient("bottom");

    let yAxis = d3.svg
      .axis()
      .scale(y)
      .innerTickSize(-w)
      .outerTickSize(0)
      .orient("left")
      .tickFormat(d3.format("s"));

    return [xAxis, yAxis];
  };

  tooltip_svg = (mouseG) => {
    const { data } = this.props;

    var newRect = mouseG
      .append("g")
      .attr("class", "newToolTip")
      .style("opacity", "0");
    newRect
      .append("rect")
      .attr("class", "new_tooltip")
      .attr("x", 0)
      .attr("y", 0)
      // .attr("width", data.length > 2 ? 230 : 180)
      .attr("width", 230)
      .attr("height", data.length > 2 ? 75 : 55)
      .style("fill", "#000")
      .style("opacity", ".8")
      .style("stroke", "none");

    newRect
      .append("g")
      .append("text")
      .attr("transform", "translate(5," + 20 + ")")
      .attr("id", "axis_date");

    newRect
      .append("g")
      .append("g")
      .attr("transform", "translate(5," + 35 + ")")
      .append("text")
      .attr("id", "portfolio_text");

    newRect
      .append("g")
      .append("g")
      .attr("transform", "translate(5," + 50 + ")")
      .append("text")
      .attr("id", "benchmark_text");

    data.length > 2
      ? newRect
          .append("g")
          .append("g")
          .attr("transform", "translate(5," + 65 + ")")
          .append("text")
          .attr("id", "Orig_benchmark_text")
      : null;
  };

  axis_svg = (svg, Axis, h) => {
    svg
      .append("g")
      .attr("class", "xxx axis")
      .attr("transform", "translate(0," + h + ")")
      .call(Axis[0])
      .selectAll("text")
      .style("text-anchor", "end")
      .attr("font-size", "10px")
      .attr("dx", "-.8em")
      .attr("dy", ".2em")
      .attr("transform", (d) => "rotate(-45)");
    svg
      .append("g")
      .attr("class", "yyy axis")
      .call(Axis[1])
      .selectAll("text")
      .attr("font-size", "12px");
  };

  componentDidMount() {
    let { data, width } = this.props;
    this.renderChart({ data, width });
  }

  componentWillReceiveProps({ data, chartId, width }) {
    if (
      width !== this.props.width ||
      JSON.stringify(data) !== JSON.stringify(this.props.data)
    ) {
      $(`#${chartId}`).empty();

      this.renderChart({ data, width });
    }
  }

  render() {
    return <div id={this.props.chartId} />;
  }
}

NewLine.propTypes = {
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  chartId: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
};
export default NewLine;



// WEBPACK FOOTER //
// ./src/components/d3Components/NewLineChart/NewLine/newLine.js